// M61 (TH 5): en la ficha del puesto, "Opera vehículos o maquinaria" y los tipos de licencia que sirven para el puesto.
import React from 'react';
import { DESCRIPCION_LICENCIA, TIPOS_LICENCIA, type TipoLicencia } from '../../lib/licencias-conduccion';

interface Props {
  opera: boolean;
  aceptadas: string[];
  onCambio: (opera: boolean, aceptadas: string[]) => void;
}

const nota: React.CSSProperties = { color: '#94a3b8', fontSize: '0.78rem', margin: 0, lineHeight: 1.45 };
const fila: React.CSSProperties = { display: 'flex', gap: 8, alignItems: 'flex-start', justifyContent: 'flex-start', textAlign: 'left', color: '#e2e8f0',
  fontSize: '0.84rem', fontWeight: 400, minHeight: 32, minWidth: 0 };
// .jp-field input pone ancho completo y relleno a los campos del formulario del puesto: las casillas van sin eso.
const casilla: React.CSSProperties = { width: 18, height: 18, flex: '0 0 auto', padding: 0, margin: '2px 0 0', accentColor: '#2FBF71' };

export default function LicenciasPuestoCampo({ opera, aceptadas, onCambio }: Props) {
  const marcar = (t: TipoLicencia, v: boolean) => onCambio(opera, v ? TIPOS_LICENCIA.filter(x => x === t || aceptadas.includes(x)) : aceptadas.filter(x => x !== t));
  return (
    <div className="jp-field" aria-label="Licencias de conducción del puesto">
      <label style={{ ...fila, alignItems: 'center', cursor: 'pointer', fontWeight: 600 }}>
        <input type="checkbox" role="switch" aria-checked={opera} checked={opera} style={{ ...casilla, margin: 0 }} onChange={e => onCambio(e.target.checked, aceptadas)} />
        Opera vehículos o maquinaria
      </label>
      <p style={nota}>Anexo 1, TH 5: el personal que opera vehículos debe tener la licencia de conducción que corresponde (DE 255 Art. 51; Reglamento a la LOTTTSV Art. 132).</p>
      {opera && (
        <fieldset style={{ border: '1px solid rgba(148,163,184,0.25)', borderRadius: 8, padding: 10, margin: 0, minWidth: 0 }}>
          <legend style={{ color: '#cbd5e1', fontSize: '0.84rem', padding: '0 4px' }}>Licencias aceptadas para el puesto (al menos una)</legend>
          {TIPOS_LICENCIA.map(t => (
            <label key={t} style={fila}>
              <input type="checkbox" checked={aceptadas.includes(t)} style={casilla} onChange={e => marcar(t, e.target.checked)} aria-label={`Tipo ${t}`} />
              <span style={{ minWidth: 0, overflowWrap: 'anywhere' }}><b>Tipo {t}</b> · {DESCRIPCION_LICENCIA[t]}</span>
            </label>
          ))}
          <p style={nota}>Descripción de cada tipo: resumen orientativo de StorSafe, no normativo (el alcance exacto lo define la ANT).</p>
        </fieldset>
      )}
    </div>
  );
}
